export const WHATSAPP_NUMBER = "351934400491"; // E.164 without +
export const WHATSAPP_DISPLAY = "+351 934 400 491";
export const EMAIL = "contato@bezierclick.com";
export const COMPANY = "BezierClick";

export const buildWhatsappLink = (
  text = "Olá! Vim pelo site da BezierClick e quero falar sobre desenvolvimento web B2B para a minha empresa.",
  source = "website"
) => {
  const sourceParam = `&utm_source=${encodeURIComponent(source)}&utm_medium=whatsapp&utm_campaign=direct_message`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}${sourceParam}`;
};
